<template>
  <g :id="id">
    <defs>
      <CircleSection
        :id="`${id}-frame`"
        :radius="$store.state.drawing_opts.inner_radius"
        :angle="$store.state.drawing_opts.item_angle"
        :rotation="rotation"
      ></CircleSection>
    </defs>
    <use
      :fill="goal_color"
      stroke="none"
      :transform="`scale(${goal_norm})`"
      :xlink:href="`#${id}-frame`"
    />
    <use
      :fill="grade_color"
      stroke="none"
      :transform="`scale(${grade_norm})`"
      :xlink:href="`#${id}-frame`"
    />
  </g>
</template>
<script>
import CircleSection from "@/components/CircleSection.vue";

export default {
  name: "Item",
  components: {
    CircleSection
  },
  props: {
    name: String,
    grade: Number,
    goal: Number,
    index: Number,
    grade_color: String,
    goal_color: String
  },
  computed: {
    grade_norm() {
      return this.grade / 10;
    },
    goal_norm() {
      return this.goal / 10;
    },
    id() {
      return `item${this.index}`;
    },
    rotation() {
      return this.$store.state.drawing_opts.item_angle * this.index;
    }
  }
};
</script>
<style lang="scss" scoped>
text {
  color: black;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 0.8em;

  textPath {
    fill: currentColor;
  }
}
</style>
